import axios from 'axios';

const initialState = {
  bulkActionsData: [],
  isLoading: false,
};

export default {
  namespaced: true,
  state: { ...initialState },
  getters: {
    getReportTitle: state => {
      if (state.bulkActionsData.length <= 0) return 'No data found';

      const { type, resource } = state.bulkActionsData[0].action;
      return ['Bulk', type, resource].join(' ');
    },
    getPayloadFields: state => {
      if (state.bulkActionsData.length <= 0) return [];

      const { payload } = state.bulkActionsData[0].action;
      return payload ? Object.entries(payload).map(([key, value]) => {
        return { label: key, value };
      }) : [];
    },
  },
  mutations: {
    setBulkActionsData(state, data) {
      state.bulkActionsData = data;
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
  },
  actions: {
    async getBulkActionsReport({ commit }, masterID) {
      try {
        commit('setIsLoading', true);
        const res = await axios.get(`${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/bulk/report/${masterID}`);
        commit('setBulkActionsData', res.data);
      } catch (error) {
        console.error(error);
      } finally {
        commit('setIsLoading', false);
      }
    },
  },
};
